import { getLeaveTypes } from "@/api/leave-types";
import { LeaveType } from "@/models/leave-types.model";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface LeaveTypeState {
  leaveTypes: LeaveType[];
  status: "idle" | "loading" | "failed" | "succeeded";
  error: string | null;
}

export const fetchLeaveTypes = createAsyncThunk(
  "leaveTypes/fetchLeaveTypes",
  async () => {
    const data: LeaveType[] = await getLeaveTypes();
    return data;
  }
);

const initialState: LeaveTypeState = {
  leaveTypes: [],
  status: "idle",
  error: null,
};

const leaveTypeSlice = createSlice({
  name: "leaveTypes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLeaveTypes.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(fetchLeaveTypes.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.leaveTypes = action.payload;
    });
    builder.addCase(fetchLeaveTypes.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.payload as string;
    });
  },
});

export default leaveTypeSlice.reducer;
